import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsUsuariorepresentanteClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/usuario-representante', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Tipo Pedido Estab');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/usuario-representante', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Tipo Pedido Estab');
    }
  }

  async findOneUsuario(id) {
    try {
      const { data } = await this.api.get(`/usuario-representante/usuario/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Tipo Pedido Estab');
    }
  }

  async findOneRepresentante(id) {
    try {
      const { data } = await this.api.get(`/usuario-representante/representante/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Tipo Pedido Estab');
    }
  }

  async destroy(usuarioid, representanteid) {
    try {
      const { data: response } = await this.api.delete(`/usuario-representante/usuario/${usuarioid}/representante/${representanteid}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Tipo Pedido Estab');
    }
  }

  async listarRepresentantesNaoSelecionados(queries) {
    try {
      return await this.api.get('/usuario-representante/representanteNaoSelecionados', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Tipo Pedido Estab');
    }
  }

  async listarRepresentantesSelecionados(queries) {
    try {
      return await this.api.get('/usuario-representante/representanteSelecionados', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Tipo Pedido Estab');
    }
  }

  async removerTodosRepresentantes(usuarioId) {
    try {
      const { data: response } = await this.api.delete(`/usuario-representante/removerTodosSelecionados/${usuarioId}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Tipo Pedido Estab');
    }
  }

  async removerSelecionadpRepresentanteSelecionado(data) {
    try {
      const { data: response } = await this.api.post('/usuario-representante/removerSelecionadpRepresentanteSelecionado', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Tipo Pedido Estab');
    }
  }

  async adicionarTodosRepresentantes(usuarioId) {
    try {
      const { data: response } = await this.api.post(`/usuario-representante/adicionarTodosRepresentantes/${usuarioId}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Tipo Pedido Estab');
    }
  }

  async adicionarSelecionadoRepresentanteNaoSelecionado(data) {
    try {
      const { data: response } = await this.api.post('/usuario-representante/adicionarSelecionadoRepresentanteNaoSelecionado', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Tipo Pedido Estab');
    }
  }
}
